export default __webpack_public_path__ + "static/media/emoji-linkedin.91229cb2.svg";